// url config file  for project

const UrlConfig = {
  fetchVehicleData: function (query: string) {
    return `/fastag/vehicleWiseTagAmount?${query}`;
  },
  fetchWalletBalance: function () {
    return `/wallet`;
  },
  autoRechargeFasTag: function () {
    return `/fastag/account`;
  },
  fetchTxnOverview: function (id: string, fromTime: string, toTime: string, txnType: string) {
    return `/fastag/txnOverview/${id}?fromTime=${fromTime}&toTime=${toTime}`;
  },
  transactionDetail: function (query: string, param: string) {
    return `/fastag/transactions/v3/${param}?${query}`;
  },
  downloadTransactions: function (query: string) {
    return `report/fastagStatement?${query}`;
  },
  downloadAllTransactions: function (query: string) {
    return `report/fastagStatement/v2?${query}`;
  },
  rechargeFastag: function () {
    return `/fastag/recharge`;
  },
  setMinimumBalance: function () {
    return `/fastag/account`;
  },
  addMoney: function () {
    return `/wallet/recharge/v2`;
  },
  fetchPaymentOptions: function (query: string) {
    return `https://secure.paytmpayments.com/fetchPaymentOptions?${query}`;
  },
  getCardType: function (query: string) {
    return `https://secure.paytmpayments.com/fetchBinDetail?${query}`;
  },
  verifyUPI: function (query: string) {
    return `https://secure.paytmpayments.com/theia/api/v1/vpa/validate?${query}`;
  },
  updateTransaction: function () {
    return `/v2/transactions/update`;
  },
  processTransaction: function (query: string) {
    return `https://secure.paytmpayments.com/theia/api/v1/processTransaction?${query}`;
  },
  fetchNBOptions: function (query: string) {
    return `https://secure.paytmpayments.com/theia/api/v1/fetchNBPaymentChannels?${query}`;
  },
  fetchPaymentResponse: function (orderId: string) {
    return `v2/transactions/${orderId}`;
  },
  fetchPassbookData: function (query?: string) {
    return `wallet/transactions?${query}`;
  },
  downloadPassbook: function (query: string) {
    return `report/wallet-transactions?${query}`;
  },
  updateVehicleDataApi(vehicleId: any) {
    return `/rest/tesseract/v1/vehicle`;
  },

  updateVehicleNumberAPi() {
    return `/rest/tesseract/v1/trip/replace-vehice`;
  },
  getVehicleReplaceMentReason() {
    return 'rest/tesseract/v1/trip/vehicle/replacement/reasons';
  },
  getCancelReasonApi(tripId: any) {
    return `rest/tesseract/v1/trip/${tripId}/cancel-reasons`;
  },
  updateCancelReasonApi(tripId: any) {
    return `rest/tesseract/v1/trip/${tripId}/cancel-confirmation`;
  },
  updateCancelReasonSubmitApi(tripId: any) {
    return `rest/tesseract/v1/trip/${tripId}/cancel`;
  },

  getLoadingTime(tripId: any) {
    return `/rest/tesseract/v2/trip/${tripId}/loading-slot`;
  },
  submitLoadingTimeApi(tripId: any) {
    return `rest/tesseract/v2/trip/${tripId}/loading-slot`;
  },
  getGltDelayLoadingSlots(tripId: string) {
    return `/rest/tesseract/v2/trip/glt-delay/${tripId}/loading-slot`;
  },
  submitGltDelayArrivalResponse(tripId: string) {
    return `/rest/tesseract/v2/trip/glt-delay/${tripId}/arrival-response`;
  },
  getTripBankDetail(tripId: string) {
    return `/rest/tesseract/v1/trip/${tripId}/bank-detail`;
  },
  submitBankAccountConsent(tripId: string) {
    return `/rest/tesseract/v1/trip/${tripId}/bank-account-consent`;
  },
  postUploadDocUrl2(payload: any) {
    return `rest/tesseract/v1/profile/document/upload-url`;
  },
  getUploadedDocImg2(payload: any, typeImg: any) {
    return `/rest/tesseract/v1/document/view-url/${payload}`;
  },
  vehicleUpdateV2() {
    return `/rest/tesseract/v1/operator/vehicles/list`;
  },
  // [POST]   /rest/tesseract/v1/vehicle/gps-eligibility
  gpsBuyEligibility(vehicleId: any) {
    return `/rest/tesseract/v1/vehicle/gps-eligibility`;
  },
  // [POST]   /rest/tesseract/v1/vehicle/install-gps
  gpsBuyAPi(vehicleId: any) {
    return `/rest/tesseract/v1/vehicle/install-gps`;
  },
  postDelayBilty(tripId: any) {
    return `rest/tesseract/v2/trip/${tripId}/notifyconsigner`;
  },
  downloadBiltiFiles(tripId: any) {
    return `rest/tesseract/v1/document/${tripId}/bilti/view-urls`;
  },
  Unsubsribe() {
    return `rest/tesseract/v1/profile/onboarding/unsubsribe`;
  },
};

export default UrlConfig;
